module.exports = __webpack_public_path__ + "static/media/text-icon-dark.eba8295f.svg";